// extracted by mini-css-extract-plugin
export default {"p_tye":"_7f6163dc36","slcted":"_733e080588","slc_color":"e779382e3e","item_p":"_3546e534e4","r0":"_0ea4e81280"};